var _excluded = ["label", "secondaryLabel", "defaultIsExpanded", "labelView", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useState } from 'react';
import { Text } from '../../components/dataDisplay';
import { Box } from '../../components/internal';
import { Icon } from '../../foundations/Icon';
import { Collapse } from '../../foundations/transitions';
import { forwardRef } from '../../utils';
import { useMultiStyleConfig } from '../../utils/use-style-config';
import { Group } from '../Group';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Collapsible = forwardRef((_ref, ref) => {
  var {
    label,
    secondaryLabel,
    defaultIsExpanded = false,
    labelView = 'default',
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('Collapsible', {});
  var [isExpanded, setIsExpanded] = useState(defaultIsExpanded);
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    "data-component": "Collapsible",
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsxs(Group, {
      variant: "vertical",
      spacing: "s",
      children: [/*#__PURE__*/_jsxs(Box, {
        __css: styles['header'],
        children: [/*#__PURE__*/_jsxs(Box, {
          __css: styles['labelAndIcon'],
          onClick: () => setIsExpanded(value => !value),
          "data-full-view": Boolean(labelView === 'full' && !secondaryLabel),
          as: "button",
          "data-testid": "collapse-trigger" // Expanded should be on the expanding parent element.
          // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-expanded
          ,
          "aria-expanded": isExpanded,
          children: [/*#__PURE__*/_jsx(Text, {
            textStyle: "inline",
            color: "inherit",
            shouldSupportEllipsis: true,
            children: label
          }), /*#__PURE__*/_jsx(Icon, {
            type: isExpanded ? 'chevron-up' : 'chevron-down',
            size: "small",
            color: "inherit"
          })]
        }), isExpanded && secondaryLabel && /*#__PURE__*/_jsx(Box, {
          __css: styles['secondaryLabel'],
          children: /*#__PURE__*/_jsx(Text, {
            textStyle: "inline",
            color: "inherit",
            shouldSupportEllipsis: true,
            children: secondaryLabel
          })
        })]
      }), /*#__PURE__*/_jsx(Collapse, {
        "data-testid": "collapse",
        in: isExpanded,
        children: children
      })]
    })
  }));
});
Collapsible.displayName = 'Collapsible';
//# sourceMappingURL=Collapsible.js.map